import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { ToasterService } from 'src/app/utils/toaster.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  public forgotPasswordForm: UntypedFormGroup;
  private email: string;
  constructor(public formBuilder: UntypedFormBuilder,
    private router: Router,
    private toasterService: ToasterService,
  ) {
    console.log('forgot password loaded');
    console.log(this.router.getCurrentNavigation().extras.state.email);
    this.email = this.router.getCurrentNavigation().extras.state.email;
  }

  ngOnInit() {
    this.forgotPasswordForm = this.formBuilder.group({
      code: ['', [Validators.required]],
      new_password: ['', [Validators.required]],
      confirm_password: ['', Validators.required]
    });

  }

  async onForgotPasswordSubmit() {
    const { code, new_password } = this.forgotPasswordForm.value;

    let passwordResult = await Auth.forgotPasswordSubmit(this.email, code, new_password);
    console.log('passwordResult', passwordResult);
    if (passwordResult === 'SUCCESS') {
      this.router.navigate(['sign-in'], { state: { email: this.email, password: new_password } });
      this.toasterService.presentToast('top', 'Password Changed - Please login', false, 'success', 'Success', 2000);
    } else {
      this.toasterService.presentToast('top', 'Password change failed!', false, 'danger', 'ERROR', 2000);

    }

  }

}
